"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _ToggleSwitch = require("./ToggleSwitch.styled");
var _UncontrolledTooltip = require("../UncontrolledTooltip");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ToggleSwitch = function ToggleSwitch(_ref) {
  var tooltipId = _ref.tooltipId,
    checked = _ref.checked,
    onClick = _ref.onClick,
    label = _ref.label,
    toolTipMessage = _ref.toolTipMessage,
    textSize = _ref.textSize,
    parentId = _ref.parentId,
    enableFeature = _ref.enableFeature,
    labelCursor = _ref.labelCursor,
    color = _ref.color,
    ddActionName = _ref.ddActionName;
  var onToggleClick = enableFeature ? onClick : function () {};
  return /*#__PURE__*/_react["default"].createElement(_ToggleSwitch.StyledCol, {
    className: "text-end",
    id: parentId
  }, /*#__PURE__*/_react["default"].createElement(_ToggleSwitch.StyledToggleSwitch, {
    on: checked,
    onClick: onToggleClick,
    enableFeature: enableFeature,
    ddActionName: ddActionName
  }), label && /*#__PURE__*/_react["default"].createElement(_ToggleSwitch.StyledText, {
    id: "tooltip-".concat(tooltipId),
    textSize: textSize,
    enableFeature: enableFeature,
    labelCursor: labelCursor,
    color: color
  }, label), toolTipMessage && enableFeature && /*#__PURE__*/_react["default"].createElement(_UncontrolledTooltip.StyledUncontrolledTooltip, {
    placement: "bottom",
    target: "tooltip-".concat(tooltipId)
  }, toolTipMessage));
};
ToggleSwitch.propTypes = {
  tooltipId: _propTypes.string,
  onClick: _propTypes.func,
  checked: _propTypes.bool,
  label: _propTypes.string,
  toolTipMessage: _propTypes.string,
  textSize: _propTypes.number,
  parentId: _propTypes.string,
  enableFeature: _propTypes.bool,
  labelCursor: _propTypes.string,
  color: _propTypes.string,
  ddActionName: _propTypes.string
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(ToggleSwitch);